import type { ReactNode } from "react";
import { isWeaponLoaded, weaponInstanceKey, type Combatant } from "@lancer-vtt/domain";
import type { EncounterDispatch } from "../StatusEditor";
import type { LoadoutRow } from "../unitLoadout";

/**
 * The GM's **RELOAD** control on a spent Loading weapon's loadout row (`set_weapon_loaded`,
 * `decisions/0209`): "the reload didn't go through", fixed without the override mode. `undefined`
 * (no row controls at all) for anyone but the GM.
 */
export function gmReloadRowActions(args: { combatant: Combatant; actorId: string | null; isGm: boolean; dispatch: EncounterDispatch }): ((row: LoadoutRow) => ReactNode) | undefined {
  const { combatant: c, actorId, isGm, dispatch } = args;
  if (!isGm || actorId === null) return undefined;
  return (row) => {
    const weapon = c.base.weapons?.find((w) => w.loading === true && weaponInstanceKey(w) === row.key);
    if (weapon === undefined || isWeaponLoaded(c.current.resources, row.key)) return undefined;
    return (
      <button
        type="button"
        className="unit-sheet-gm-reload"
        aria-label={`reload ${row.name}`}
        title="GM: mark this Loading weapon loaded"
        onClick={() => dispatch({ type: "set_weapon_loaded", actorId, combatantId: c.id, weapon: row.key, loaded: true })}
      >
        RELOAD
      </button>
    );
  };
}
